const initHeaderH1 = () => {
	const component = document.querySelector( 'section.header-h1' );
	
	if ( !component ) {
		return;
	}

	const button = component.querySelector( 'button' );
	if ( document.referrer.includes( window.location.hostname ) && button )
	{
		button.style.display = 'flex';
	}
};

export {
	initHeaderH1,
};
